import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AdModalContextType {
  isAdModalOpen: boolean;
  setIsAdModalOpen: (open: boolean) => void;
  openAdModal: () => void;
}

const AdModalContext = createContext<AdModalContextType | undefined>(undefined);

export const AdModalProvider = ({ children }: { children: ReactNode }) => {
  const [isAdModalOpen, setIsAdModalOpen] = useState(false);

  const openAdModal = () => {
    setIsAdModalOpen(true);
  };

  return (
    <AdModalContext.Provider value={{ isAdModalOpen, setIsAdModalOpen, openAdModal }}>
      {children}
    </AdModalContext.Provider>
  );
};

export const useAdModal = () => {
  const context = useContext(AdModalContext);
  if (context === undefined) {
    throw new Error('useAdModal must be used within an AdModalProvider');
  }
  return context;
};